<template>
	<div class="p-admin">
		<Onboarding></Onboarding>
		<!-- <div class="container">
      <div class="row">
        <div class="col-12">
          <h3>
            Admin
          </h3>
          <b-table striped hover :items="items.items"></b-table>
        </div>
      </div>
    </div> -->
	</div>
</template>

<script>
import microNotification from '@/components/micro-notification.vue';
import backgroundSelect from '@/components/ui/background-select';
import signup from '@/components/forms/signup.vue';
import BackgroundSelect from '../components/ui/background-select.vue';
//import Onboarding from '../components/onboarding';

export default {
	components: {
		signup,
		backgroundSelect,
		microNotification,
		//Onboarding,
	},
	data: function () {
		BackgroundSelect;
		return {
			mode: 'local',
			activationText: '',
			form: {
				content: '',
			},
			toggleOptions: [
				{
					text: 'Closed by default but remembers the state.',
					value: 'default',
				},
				{
					text: 'Always closed by default',
					value: 'close',
				},
				{
					text: 'Always opened by default',
					value: 'open',
				},
			],
			ui: {},
			lock: false,
			error: '',
		};
	},
	watch: {
		mode: function () {
			window.mode = this.mode;
		},
		uiState: {
			handler: function () {
				this.ui = this.uiState;
			},
			immediate: true,
		},
	},
	computed: {
		items: function () {
			return {
				items: [
					{ age: 40, first_name: 'Dickerson', last_name: 'Macdonald' },
					{ age: 21, first_name: 'Larsen', last_name: 'Shaw' },
					{ age: 89, first_name: 'Geneva', last_name: 'Wilson' },
					{ age: 38, first_name: 'Jami', last_name: 'Carney' },
				],
			};
		},
		avatar: function () {
			return this.$store.getters['user/avatar'];
		},
		uiState: function () {
			return this.$store.getters['settings/ui'];
		},
		json: function () {
			var obj = {
				notes: this.notes,
			};
			return JSON.stringify(obj);
		},
		version: function () {
			return this.$store.getters.version;
		},
		notes: function () {
			return this.$store.getters['note/notes'];
		},
	},
	methods: {
		onBackgroundChange: function (background) {
			this.ui.backgroundImage = background;
		},
		onSettingsSave: function () {
			this.$refs.notification.activate();
			this.$store.dispatch('settings/saveUiState', this.ui);
		},
		onSubmit: function () {
			this.lock = true;
			this.$store.dispatch('ui/sendContact', this.form).then(() => {
				this.lock = false;
				this.error = 'Form sent successfully';
			});
		},
		onBackup: function () {
			this.$store.dispatch('backup');
		},
		onActivate: function () {
			this.$store
				.dispatch('backgroundCheck')
				.then((data) => {
					this.activationText = data.message;
				})
				.catch((err) => {
					console.log(err);
				});
		},
	},
	mounted: function () {
		this.mode = window.mode || 'local';
	},
	beforeRouteEnter: function (to, from, next) {
		next();
	},
};
</script>

<style lang="scss">
.p-admin {
	padding: 1.5rem;

	.shortkey {
		display: inline-block;
		padding: 3px 10px;
		border-radius: 4px;
		background: linear-gradient(
			180deg,
			rgba(255, 255, 255, 0.225) 0%,
			rgba(255, 255, 255, 0.2) 33%,
			rgba(255, 255, 255, 0.15) 100%
		);
		text-shadow: 0 1px 0 rgba(255, 255, 255, 0.2), 0 -1 0 rgba(0, 0, 0, 0.25);
		box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.5),
			0 -1px 2px 0 rgba(255, 255, 255, 0.1);
	}

	.contact {
		padding: 1rem;
		background-color: rgba(255, 255, 255, 0.1);
		border-radius: 7px;
		p {
			&:last-child {
				margin-bottom: 0;
			}
		}
	}

	.custom-control {
		padding-left: 26px;
		margin-bottom: calc(var(--size-v) * 4);
	}

	.infobox {
		position: relative;
		margin-bottom: 1rem;

		padding: 1rem;
		border-radius: 7px;
		background-color: var(--s3);
		box-shadow: 0 1.8px 3px rgba(0, 0, 0, 0.048),
			0 6px 10.1px rgba(0, 0, 0, 0.072), 0 27px 45px rgba(0, 0, 0, 0.12);

		&:after {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			border-radius: 7px;
			pointer-events: none;
			background: linear-gradient(
				356deg,
				rgba(255, 255, 255, 0.09) 0%,
				rgba(255, 255, 255, 0.15) 70%
			);
		}
	}
}
</style>
